<template>
  <div class="min-h-screen relative">
    <Header />
    <!-- <FlashMessage v-if="this.messages.text != ''" :message="this.messages" /> -->

    <div
      class="min-h-screen container mx-auto max-w-[1200px] w-full mb-10 py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div
        v-if="loading"
        class="flex items-center justify-center"
        style="height: calc(100vh - 350px) !important"
      >
        <img src="@/assets/newd/loading.gif" alt="" />
      </div>
      <!-- new -->
      <div v-else class="p-4">
        <div class="flex flex-wrap gap-2 mb-4">
          <!-- {{  }} -->
          <!-- {{ this.sem_course[0].semester }} 
          {{ activeTab }}  -->

          <div
            v-if="sem_course.length == 0"
            class="flex justify-center w-full sm:p-6 h-auto"
          >
            <p class="text-sm">No Semesters</p>
          </div>

          <!-- <button
            v-for="tab in sem_course"
            :key="tab.semester"
            @click="selectTab(tab)"
            :class="[
              'px-4 py-2 rounded text-sm transition duration-200',
              activeTab === tab.semester
                ? 'bg-blues text-white'
                : semesterToNumber(tab.semester) <=
                  semesterToNumber(userInfo.current_semester.semester)
                ? 'bg-gray-300 text-gray-700 hover:bg-gray-300'
                : // Future semesters → lighter gray
                  'bg-gray-200 text-gray-500 hover:bg-gray-300',
            ]"
          >
            Semester<b class="pl-1">{{ tab.semester }}</b>
          </button> -->
          <!-- <template v-for="tab in sem_course">
            <button
              v-if="tab.semester === userInfo.current_semester.semester"
              :key="tab.semester"
              @click="selectTab(tab)"
              class="px-4 py-2 rounded text-sm transition duration-200 bg-blues text-white"
            >
              Semester<b class="pl-1">{{ tab.semester }}</b>
            </button>
          </template> -->

          <!-- new -->
          <div v-for="tab in sem_course" :key="tab.semester">
            <button
             v-if="semesterToNumber(tab.semester) <= semesterToNumber(userInfo.current_semester.semester)"
              @click="selectTab(tab)"
              :class="[
                'px-4 py-2 rounded text-sm transition duration-200',
                activeTab === tab.semester &&
                activeDepartment === tab.department.name
                  ? 'bg-blues text-white'
                  : semesterToNumber(tab.semester) <=
                    semesterToNumber(userInfo.current_semester.semester)
                  ? 'bg-gray-200 border text-gray-700 hover:bg-gray-300'
                  : 'bg-gray-200 text-gray-500 hover:bg-gray-300',
              ]"
            >
              Semester <b class="pl-1">{{ tab.semester }}</b>
              <span
                class="ml-2 text-xs font-bold"
                :class="
                  activeTab === tab.semester &&
                  activeDepartment === tab.department.name
                    ? 'text-white'
                    : 'text-gray-600'
                "
              >
                ({{ tab.department.name }})
              </span>
            </button>
          </div>
        </div>

        <div v-if="activeTab">
          <div class="flex flex-row items-center justify-between">
            <p
              class="text-[#0F172A] text-lg sm:text-xl md:text-xl font-semibold"
            >
              My Courses
            </p>
          </div>

          <div class="">
            <!-- {{ getCourseListbySemester[0].course }} -->
            <div v-if="this.getCourseListbySemester.length > 0">
              <div
                v-if="getCourseListbySemester[0]"
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6"
              >
                <div
                  v-for="course in this.getCourseListbySemester[0].course ||
                  this.getCourseListbySemester[0]"
                  :key="course"
                  class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
                  :class="{
                    'cursor-not-allowed bg-gray-100 opacity-70':
                      this.getCourseListbySemester[0].semester >
                      userInfo.current_semester.semester,
                    'cursor-pointer':
                      this.getCourseListbySemester[0].semester <=
                      userInfo.current_semester.semester,
                  }"
                  @click="
                    this.getCourseListbySemester[0].semester <=
                    userInfo.current_semester.semester
                      ? getDashboardOrPreviewUp(course.id)
                      : null
                  "
                >
                  <div>
                    <div class="relative flex justify-center items-center">
                      <img
                        v-if="course.thumbnail"
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        :src="course.thumbnail"
                        alt="Course Thumbnail"
                      />
                      <img
                        v-else
                        class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                        src="@/assets/coding.svg"
                        alt="Placeholder"
                      />
                    </div>
                    <div class="text-center flex flex-col gap-2 mt-2">
                      <p
                        class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                      >
                        {{ course.title }}
                      </p>
                      <!-- <p class="text-xs sm:text-sm text-gray-600 text-left">
                        {{ course.section_count }} Module
                      </p> -->

                      <p class="text-xs sm:text-sm text-gray-600 text-left">
                        <span class="font-bold">Course Code:</span>
                        {{ course.course_code }}
                      </p>

                      <p class="text-xs sm:text-sm text-gray-600 text-left hidden">
                        <span class="font-bold">Instructor Name:</span>
                        {{ course.instructor }}
                      </p>

                      <p
                        @click="
                          this.getCourseListbySemester[0].semester <=
                          userInfo.current_semester.semester
                            ? getDashboardOrPreviewUp(course.id)
                            : null
                        "
                        :class="{
                          'cursor-not-allowed bg-gray-100 opacity-70':
                            this.getCourseListbySemester[0].semester >
                            userInfo.current_semester.semester,
                          'cursor-pointer':
                            this.getCourseListbySemester[0].semester <=
                            userInfo.current_semester.semester,
                        }"
                        class="mt-3 py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] hover:bg-blue-600 hover:text-white text-[#0F172A] font-medium text-center"
                      >
                        Continue Learning
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  v-if="this.getCourseListbySemester[0].course.length == 0"
                  class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
                >
                  <p class="text-sm">No Courses</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- old -->
      <div class="hidden">
        <div class="flex flex-row items-center justify-between">
          <p
            class="text-[#0F172A] text-xl sm:text-2xl md:text-3xl font-semibold"
          >
            My Courses
          </p>
        </div>

        <div
          v-if="loading"
          class="flex items-center justify-center"
          style="height: calc(100vh - 350px) !important"
        >
          <img src="@/assets/newd/loading.gif" alt="" />
        </div>
        <div class="" v-else>
          <div v-if="this.courseDetails.length > 0">
            <div
              v-if="this.courseDetails[0]"
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6"
            >
              <div
                v-for="course in this.courseDetails[0].course"
                :key="course"
                class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
              >
                <!-- <router-link 
                  :to="{
                    name: 'StudentCourse',
                    params: { courseid: course.id },
                  }"
                >
                  <div class="relative flex justify-center items-center">
                    <img
                      v-if="course.thumbnail"
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Placeholder"
                    />
                  </div>
                  <div class="text-center flex flex-col gap-2 mt-2">
                    <p
                      class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                    >
                      {{ course.title }}
                    </p>
                    <p class="text-xs sm:text-sm text-gray-600 text-left">
                      {{ course.sections.length }} Units
                    </p>

                    <p
                      class="mt-3 py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                    >
                      Continue Learning
                    </p>
                  </div>
                </router-link> -->

                <div
                  @click="getDashboardOrPreviewUp(course.id)"
                  class="cursor-pointer"
                >
                  <div class="relative flex justify-center items-center">
                    <img
                      v-if="course.thumbnail"
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      :src="course.thumbnail"
                      alt="Course Thumbnail"
                    />
                    <img
                      v-else
                      class="object-cover h-[180px] sm:h-[200px] w-full rounded-lg"
                      src="@/assets/coding.svg"
                      alt="Placeholder"
                    />
                  </div>
                  <div class="text-center flex flex-col gap-2 mt-2">
                    <p
                      class="text-sm sm:text-base text-gray-600 font-semibold text-left truncate"
                    >
                      {{ course.title }}
                    </p>
                    <p class="text-xs sm:text-sm text-gray-600 text-left">
                      {{ course.sections.length }} Units
                    </p>

                    <p
                      @click="getDashboardOrPreviewUp(course.id)"
                      class="mt-3 cursor-pointer py-2 text-xs sm:text-sm rounded-lg border border-[#0085DB] text-[#0F172A] font-medium text-center"
                    >
                      Continue Learning
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="this.courseDetails[0].course.length == 0"
                class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto"
              >
                <p class="text-sm">No Courses</p>
              </div>
            </div>

            <div v-else class="bg-white shadow-lg rounded-lg p-4 sm:p-6 h-auto">
              <p class="text-sm">No Courses</p>
            </div>
          </div>

          <div
            v-else
            class="flex flex-col justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <p class="flex justify-center">No Courses</p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Student/Header.vue";

export default {
  data() {
    return {
      profileInfo: null,
      popUp: false,
      updateDetails: null,
      selectedFile: null,
      tnxDetails: "",
      profile: false,
      // messages: {
      //   text: "",
      //   type: "null",
      // },
      selectedcontent: "Courses",
      // courseDetails: null,
      courseDetails: [],
      boughtcourse: null,
      progress: 90,
      loading: true,
      activeTab: null,
      sem_course: [],
      sem_courselist: [],
      getCourseListbySemester: [],
    };
  },

  components: {
    Header,
    // FlashMessage,
    Footer,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    // this.activeTab = this.userInfo.current_semester.semester;
    if (!localStorage.getItem("previewIgnoreList")) {
      localStorage.setItem("previewIgnoreList", JSON.stringify([]));
    }

    // setTimeout(()=>{

    //   // console.log("get::", this.sem_course);

    //   if (this.sem_course[0]) {
    //     this.activeTab = this.sem_course[0].semester;
    //     this.getsemestercourse(this.sem_course[0].semester);
    //   }
    // }, 100)
  },

  async created() {
    this.getsemester();

    //   await axios
    //     .get(`${process.env.VUE_APP_API}/courses/?format=json`)
    //    .then((response) => {
    // this.courseDetails = response.data.data;
    // this.loading = false;

    // https://api.galecta.com/studentsbuycoursedetails/?Key=cff90a4514d5ab813c34782fe83297598cdf099e
    // });

    await axios
      .get(
        `${process.env.VUE_APP_API}/studentsbuycoursedetails/?Key=${this.userInfo.token_key}`,
      )
      .then((response) => {
        if (response.data.status == 200) {
          this.courseDetails = response.data.data;
        }
      })
      .catch((err) => {
        console.log("error", err);
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 600);
      });
  },

  methods: {
    semesterToNumber(sem) {
      const map = { I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6 };
      return map[sem] || 0;
    },
    isDisabled(tab) {
      const current = this.semesterToNumber(
        this.userInfo.current_semester.semester,
      );
      const tabSem = this.semesterToNumber(tab.semester);
      return tabSem > current;
    },
    selectTab(tab) {
      this.getsemestercourse(tab.id);
      this.activeTab = tab.semester;
      this.activeDepartment = tab.department.name;
    },

    getDashboardOrPreviewUp(id) {
      if (localStorage.getItem("previewIgnoreList")) {
        let preList = new Set(
          JSON.parse(localStorage.getItem("previewIgnoreList")),
        );

        if (preList.size != 0) {
          if (preList.has(id.toString())) {
            this.$router.push({
              name: "StudentCourseProgress",
              params: { course_id: id },
            });
          } else {
            this.$router.push({
              name: "StudentCourse",
              params: { courseid: id },
            });
          }
        } else {
          this.$router.push({
            name: "StudentCourse",
            params: { courseid: id },
          });
        }
      } else {
        this.$router.push({ name: "StudentCourse", params: { courseid: id } });
      }
    },

    // old
    // async getsemester() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
    //     )
    //     .then((response) => {
    //       if (response.data.data.status == 200) {
    //         console.log("this.sem_course12", response.data.data.status);
    //         this.sem_course = response.data.data.data[0].semester.reverse();
    //         const currentSem = this.userInfo.current_semester.semester;
    //         const found = this.sem_course.find(
    //           (tab) => tab.semester === currentSem,
    //         );

    //         if (found) {
    //           this.activeTab = found.semester;
    //           this.getsemestercourse(found.semester);
    //         } else if (this.sem_course[0]) {
    //           this.activeTab = this.sem_course[0].semester;
    //           this.getsemestercourse(this.sem_course[0].semester);
    //         }

    //         console.log("this.sem_course", this.sem_course);
    //         setTimeout(() => {
    //           this.loading = false;
    //         }, 600);
    //       }
    //     });
    // },

    // new
    async getsemester() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.sem_course = response.data.data.data[0].semester.reverse();
            const currentSem = this.userInfo.current_semester.semester;
            const currentDepartment = this.userInfo.current_semester.department;
            const found = this.sem_course.find(
              (tab) =>
                tab.semester === currentSem &&
                tab.department.name === currentDepartment,
            );

            if (found) {
              this.activeTab = found.semester;
              this.activeDepartment = found.department.name;
         

              this.getsemestercourse(found.id);
            } else if (this.sem_course[0]) {
              this.activeTab = this.sem_course[0].semester;
              this.activeDepartment = this.sem_course[0].department.name;
            

              this.getsemestercourse(this.sem_course[0].id);
            }

            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        });
    },

    async getsemestercourse(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.userInfo.user.id}/?semester__id=${id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            // this.getCourseListbySemester = response.data.data.data[0].semester;
            const semesterData = response.data.data.data[0].semester;

            this.getCourseListbySemester = semesterData.map((sem) => ({
              ...sem,
              course: sem.course.filter(
                (course) => course.published_course?.published === true,
              ),
            }));
          }
        });
    },
  },
};
</script>

<style scoped></style>
